<template>
    <strong class="text-xl mt-8 block" v-if="faqs.length > 0 && !hide_heading">Veelgestelde vragen</strong>
    <div class="py-4 md:py-4" v-for="category in faqs" :key="category.id">
        <div class="w-full">
            <strong v-if="faqs.length > 1">{{ category.title }}</strong>
            <div class="mx-auto w-full py-1" v-for="faq in category.questions" :key="faq.id">
                <Disclosure v-slot="{ open }">
                    <div
                        class="w-full rounded-md bg-white transition-all border border-gray-300 hover:border-gray-400 focus:outline-hidden hover:shadow-md"
                        :class="open ? 'border-gray-400 shadow-md' : ''"
                    >
                        <DisclosureButton
                            class="w-full flex justify-between font-semibold text-left px-4 py-3"
                            :class="open ? '' : ''"
                        >
                            <span>{{ faq.question }}</span>

                            <fa
                                :icon="['fal', 'angle-down']"
                                class="ml-2 h-5 w-5 group-hover:text-gray-600"
                                :class="open ? 'rotate-180 transform' : ''"
                            />
                        </DisclosureButton>
                        <transition
                            enter-active-class="transition duration-100 ease-out"
                            enter-from-class="transform scale-95 opacity-0"
                            enter-to-class="transform scale-100 opacity-100"
                            leave-active-class="transition duration-75 ease-out"
                            leave-from-class="transform scale-100 opacity-100"
                            leave-to-class="transform scale-95 opacity-0"
                        >
                            <DisclosurePanel class="px-4 pr-12 py-3 text-gray-600" static v-show="open">
                                <div class="d-prose" v-html="faq.answer"></div>
                            </DisclosurePanel>
                        </transition>
                    </div>
                </Disclosure>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue';

const props = defineProps({
    faqs: Object,
    hide_heading: Boolean,
});


</script>
